export enum ToastType{
  Success='toast-success',
  Warning='toast-warning',
  Error='toast-error'
}
